﻿$.fn.dxCtrlContentEmailEditor = function custom_dxCtrlContentEmailEditor(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentemaileditor dx-ctrl");
        this.createInstance(new cdxCtrlContentEmailEditor(this, option));
    }
    return this;
}

window.cdxCtrlContentEmailEditor = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var isDirty = false
    this.isDirty = function (value) {
        if (typeof value != 'undefined') {
            isDirty = value
            lstTagIsDirty = value
            if (dxAssistant) dxAssistant.isDirty(value)
            if (dxHtmlEditor) dxHtmlEditor.isDirty(value)
        }
        return isDirty || lstTagIsDirty || ((dxAssistant) ? dxAssistant.isDirty() : false) || ((dxHtmlEditor) ? dxHtmlEditor.isDirty() : false)
    }

    this.isInit = false
    var dxAssistant = null
    var dxHtmlEditor = null
    var $DivEditor = null
    var $DivMiseEnPage = null
    var $DivMiseEnPageInterne = null

    var fontFamilyFormat = 'Andale Mono=andale mono, times; Arial=arial, helvetica, sans-serif; Arial Black=arial black, avant garde; Book Antiqua=book antiqua, palatino; Comic Sans MS=comic sans ms, sans-serif; Courier New=courier new, courier; Georgia=georgia, palatino; Helvetica=helvetica; Impact=impact, chicago; Symbol=symbol; Tahoma=tahoma, arial, helvetica, sans-serif; Terminal=terminal, monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms, geneva; Verdana=verdana, geneva; Webdings=webdings; Wingdings=wingdings, zapf dingbats'
    var fontSizeFormats = '8px 10px 12px 14px 16px 18px 24px 36px 48px'
    var lineHeightFormat = "50% 60% 70% 80% 90% 100% 110% 120% 130% 140% 150% 200%"

    var popupFullScreen = null
    function mConstruit() {
        container.empty()
        if (!option.fullScreen) {
            var $DivTot = $("<div style='width:100%;height:100%;'/>").appendTo(container)
            mRempli($DivTot)
        } else {
            popupFullScreen = $("<div/>").appendTo("body").dxCtrlPopupBase({
                fullScreen: true,
                showTitle: false,
                contentTemplate: function (contentElement) {
                    contentElement.css("padding", "20px")
                    contentElement.css("position", "relative")
                    $("<div style='position:absolute;z-index:101;top:2px;right:2px'/>").appendTo(contentElement).dxCtrlButton({
                        icon: 'fas fa-times',
                        width: HeightButton - 10,
                        height: HeightButton - 10,
                        onClick: function (e) {
                            popupFullScreen.hide()
                            popupFullScreen = null
                            option.onSwitchFullScreen()
                        }
                    }).dxCtrlButton("instance");
                    var $Div = $("<div style='width:100%;height:100%;'/>").appendTo(contentElement)
                    mRempli($Div)
                }
            }).dxCtrlPopupBase("instance")
            popupFullScreen.show()
        }
    }

    var ctrlResize = null
    function mRempli(contentElement) {
        if (typeof option.bddCtrl.utiCourantParaJson["editorhtml"] == 'undefined') option.bddCtrl.utiCourantParaJson["editorhtml"] = {}
        option.bddCtrl.utiCourantParaJson["editorhtml"].splitter_collapsed_right = true
        ctrlResize = $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlSplitterResize2({
            bddCtrl: option.bddCtrl,
            context_grid: "editorhtml",
            collapsibleLeft: false,
            collapsibleRight: false,
            widthLeftInitial: 350
        }).dxCtrlSplitterResize2("instance")
        ctrlResize.mConstruitLeft(function (contentElementLeft) {
            $DivEditor = contentElementLeft
        })
        //contentElement.css("position", "relative")
        //$DivEditor = $("<div style='position:absolute;width:100%;height:100%;'/>").appendTo(contentElement)
        //$DivMiseEnPage = $("<div style='position:absolute;width:0%;height:100%;padding:0 5px;'/>").appendTo(contentElement)
        //$DivMiseEnPageInterne = $("<div style='padding:5px 0;border-radius:10px;position:relative;background-color:" + theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ",0.6)") + ";height:100%;'/>").appendTo($DivMiseEnPage)
        if (option.dataHtml.html.isAssistant()) {
            //on a un fichier venu de l'assistant       
            if (option.readOnly) {
                //on affiche le doc dans une iframe
                $("<iframe src='" + option.dataHtml.urlhtml + "' style='width:100%;height:100%;box-sizing:border-box;border:none;'>").appendTo($DivEditor)
            } else {
                mSwitchVersAssistantHtml(option.dataHtml.urlhtml, option.dataHtml.html, option.dataHtml.lstfileheberge)
            }
        } else {
            mSwitchVersEditeurHtml(option.dataHtml.html)
        }
    }

    function mSwitchVersEditeurHtml(html, funcFin) {
        if (container.closest("body").length==0) return
        var jauge = null
        if (container.closest(".dx-popup-normal").length > 0) {
            jauge = $("<div/>").appendTo($(container.closest(".dx-popup-normal")[0])).dxCtrlJauge({}).dxCtrlJauge("instance")
        } else if (container.closest(".dx-ctrlpagepopupdiv").length > 0 && $(container.closest(".dx-ctrlpagepopupdiv")[0]).getInstance().popup != null) {
            jauge = $(container.closest(".dx-ctrlpagepopupdiv")[0]).getInstance().popup.jauge
        } else {
            jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        }
        ////var jauge = $("<div/>").appendTo(((container.closest(".dx-popup-normal").length > 0) ? $(container.closest(".dx-popup-normal")[0]) : ((container.closest(".dx-ctrlpagepopupdiv").length > 0) ? $(container.closest(".dx-ctrlpagepopupdiv")[0]) : container))).dxCtrlJauge({}).dxCtrlJauge("instance")
        //var jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        //window.setTimeout(function () { jauge.mShow() }, 500)
        if (typeof option.allowJaugeSwitchEditeur == 'undefined' || option.allowJaugeSwitchEditeur)   jauge.mShow()
        $DivEditor.empty()
        dxAssistant = null
        Me.isInit = false
        if (option.dxBtUndo) option.dxBtUndo.option("visible",false)
        if (option.dxBtRedo) option.dxBtRedo.option("visible", false)
        dxHtmlEditor = $("<div style='width:100%;height:100%;border:" + theme.border + ";'/>").appendTo($DivEditor).dxCtrlHtmlEditorEmail({
            bddCtrl: option.bddCtrl,
            readOnly: option.readOnly,
            html: html,
            idTestAcid: option.dataHtml.idTestAcid,
            dateTestAcid: option.dataHtml.dateTestAcid,
            //fontFamilyFormat: fontFamilyFormat,
            fontSizeFormats: fontSizeFormats,
            lineHeightFormat: lineHeightFormat,
            allowAssistant: option.allowAssistant,
            allowMiseEnPage: option.allowMiseEnPage,
            removeMenuFont: option.removeMenuFont,
            allowMenu: option.allowMenu,
            allowFullScreen: option.allowFullScreen,
            allowTag: option.allowTag,
            allowShowMessageNavigateur: option.allowShowMessageNavigateur,
            htmlDefaut: option.htmlDefaut,
            buttons: option.buttons,
            viewInBrowser: option.viewInBrowser,
            allowPreviewTest: option.allowPreviewTest,
            onDemandeObjet: option.onDemandeObjet,
            onDemandeHtml: function () { return Me.mGetHtml() },
            onDemandePrevisualisation: function () {
                option.onDemandePrevisualisation()
            },
            onDemandeUrl: option.onDemandeUrl,
            onClickAssistant: function (target) {
                var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                    target: target,
                    contentTemplate: function (contentElement) {
                        contentElement.css("padding", "24px");
                        $("<div style='padding-bottom:15px'>En passant en mode assistant HTML,<br/>vous aller perdre le contenu de votre email.</div>").appendTo(contentElement)
                        $("<div/>").appendTo(contentElement).dxCtrlButton({
                            text: "confirmez",
                            onClick: function (e) {
                                tt.hide()
                                isDirty = true
                                dxHtmlEditor = null
                                mSwitchVersAssistantHtml("", "", [])
                            }
                        });
                    }
                }).dxCtrlTooltip("instance");
                tt.show()
            },
            onDemandeMiseEnPage: function ($Body, funcChange) {
                mShowHideMiseEnPage($Body, $Body, funcChange)
            },
            onDemandeTag: function (elementEditorHtml) { mShowHideListTag(elementEditorHtml); },
            fullScreen: option.fullScreen,
            onAddFiles: option.onAddFiles,
            onSwitchFullScreen: function () {
                if (popupFullScreen) popupFullScreen.hide()
                popupFullScreen = null
                option.onSwitchFullScreen()
            },
            onContentReady: function () {
                Me.isInit = true
                if (typeof option.onContentReady != 'undefined') option.onContentReady()
                if (typeof funcFin != 'undefined' && funcFin != null) funcFin()
                jauge.element().remove()
            }
        }).dxCtrlHtmlEditorEmail("instance")


        if (typeof option.dataHtml.lstChampSaisie != 'undefined' && option.dataHtml.lstChampSaisie.length > 0) {
            mShowHideListTag(dxHtmlEditor);
        }
    }

    function mSwitchVersAssistantHtml(urlHtml, html, lstfileheberge, onContentReady) {
        var jauge = null
        if (container.closest(".dx-popup-normal").length > 0) {
            jauge = $("<div/>").appendTo($(container.closest(".dx-popup-normal")[0])).dxCtrlJauge({}).dxCtrlJauge("instance")
        } else if (container.closest(".dx-ctrlpagepopupdiv").length > 0 && $(container.closest(".dx-ctrlpagepopupdiv")[0]).getInstance().popup != null) {
            jauge = $(container.closest(".dx-ctrlpagepopupdiv")[0]).getInstance().popup.jauge
        } else {
            jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        }
        //var containerPop = ((container.closest(".dx-popup-normal").length > 0) ? $(container.closest(".dx-popup-normal")[0]) : ((container.closest(".dx-ctrlpagepopupdiv").length > 0) ? $(container.closest(".dx-ctrlpagepopupdiv")[0]) : container))
        //var jauge = $("<div/>").appendTo(containerPop).dxCtrlJauge({}).dxCtrlJauge("instance")
        //var jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        if (typeof option.allowJaugeSwitchEditeur == 'undefined' || option.allowJaugeSwitchEditeur)   jauge.mShow()
        $DivEditor.empty()
        dxHtmlEditor = null
        Me.isInit = false

        if (dxCtrlLstTag) mShowHideListTag()
        if (option.dxBtUndo) option.dxBtUndo.option("visible", true)
        if (option.dxBtRedo) option.dxBtRedo.option("visible", true)

        //if (option.dataHtml.html.contains('<html lang="fr" assistant="1">')) {
        dxAssistant = $("<div style='width:100%;height:100%;'/>").appendTo($DivEditor).dxCtrlAssistantHtmlEmail({
            bddCtrl: option.bddCtrl,
            urlHtml: urlHtml,
            html: html,
            dataHtml: option.dataHtml,
            dxBtUndo: option.dxBtUndo,
            dxBtRedo: option.dxBtRedo,
            //lstfileheberge: lstfileheberge,
            onDemandeIdComEmailEnvoi: option.onDemandeIdComEmailEnvoi,
            idTestAcid: option.dataHtml.idTestAcid,
            dateTestAcid: option.dataHtml.dateTestAcid,
            onPasseEditeur: function () {
                isDirty = true
                var html = dxAssistant.mGetHtml()
                debugger;
                html = html.split('assistant2="1"')[0] + html.split('assistant2="1"')[1]
                //html = html.replace('<html lang="fr" assistant="1">', '<html lang="fr">')
                //html = html.replace('<html lang="fr" assistant2="1">', '<html lang="fr">')
                //html = html.replace('<body class="builderjs-layout">', '<body>')
                dxAssistant = null;
                mSwitchVersEditeurHtml(html)
            },
            onDemandePrevisualisation: function () {
                option.onDemandePrevisualisation()
            },
            onNewTest: function (idTest) {
                option.onNewTest(idTest)
            },
            onDeclencheSaveAuto: option.onDeclencheSaveAuto,
            allowPreviewTest: option.allowPreviewTest,
            viewInBrowser: option.viewInBrowser,
            onDemandeObjet: option.onDemandeObjet,
            onDemandeHtml: function () { return Me.mGetHtml() },
            onDemandeUrl: option.onDemandeUrl,
            onDemandeMiseEnPage: function ($Body, $ElementArrierePlan, funcChange) {
                mShowHideMiseEnPage($Body, $ElementArrierePlan, funcChange)
            },
            //onDemandeTag: function (elementEditorHtml) { mShowHideListTag(elementEditorHtml); },
            fullScreen: option.fullScreen,
            onSwitchFullScreen: function () {
                if (popupFullScreen) popupFullScreen.hide()
                popupFullScreen = null
                option.onSwitchFullScreen()
            },
            onContentReady: function (component) {
                dxAssistant = component
                Me.isInit = true
                if (typeof option.onContentReady != 'undefined') option.onContentReady()
                if (typeof onContentReady != 'undefined') onContentReady()
                jauge.element().remove()
            }
        }).dxCtrlAssistantHtmlEmail("instance")
        //} else if (option.dataHtml.html.contains('<html lang="fr" assistant2="1">')) {
        //}
    }

    var miseEnPageIsDisplayed = false
    var contentElementTagMiseEnPage = null
    var dxCtrlMiseEnPage = null
    function mShowHideMiseEnPage($Body, $ElementArrierePlan, funcChange) {
        if (dxCtrlMiseEnPage) {
            //on est sur la mise en page
            //contentElementTagMiseEnPage.remove()
            contentElementTagMiseEnPage = null
            dxCtrlMiseEnPage.element().remove()
            dxCtrlMiseEnPage = null
            ctrlResize.mHideRight()
        } else if (contentElementTagMiseEnPage == null) {
            //le splitter right n'est pas visible
            ctrlResize.mShowRight()
            ctrlResize.mConstruitRight(function (contentElementRight) {
                contentElementTagMiseEnPage = contentElementRight
                contentElementTagMiseEnPage.css({
                    "position": "relative",
                    "background-color": theme.backgroundcolorTooltip
                })
                mShow()
            })
        } else {
            //le splitter right est visible avec les tag dedans
            dxCtrlLstTag.element().fadeOut(300, function () {
                dxCtrlLstTag.element().remove();
                dxCtrlLstTag = null;
            })
            mShow()
        }

        function mShow() {
            dxCtrlMiseEnPage = $("<div style='padding-left:5px;width:100%;height:100%;position:absolute;display:none;border-top:" + theme.border + ";border-bottom:" + theme.border + ";border-right:" + theme.border + ";'/>").appendTo(contentElementTagMiseEnPage).dxCtrlEmailMiseEnPage({
                bddCtrl: option.bddCtrl,
                fontFamilyFormat: fontFamilyFormat,
                fontSizeFormats: fontSizeFormats,
                lineHeightFormat: lineHeightFormat,
                isAssistant: (dxAssistant != null),
                body: $Body,
                elementArrierePlan: $ElementArrierePlan,
                onValueChanged: funcChange,
                onClose: function () { mShowHideMiseEnPage($Body); }
            }).dxCtrlEmailMiseEnPage("instance")
            dxCtrlMiseEnPage.element().fadeIn(300)
        }
    }

    var dxCtrlLstTag = null
    var lstTagIsDirty = false
    function mShowHideListTag(elementEditorHtml) {
        if (dxCtrlLstTag) {
            //on est sur la mise en page
            //contentElementTagMiseEnPage.remove()
            dxCtrlLstTag.element().remove()
            dxCtrlLstTag = null
            contentElementTagMiseEnPage = null
            ctrlResize.mHideRight()
        } else if (contentElementTagMiseEnPage == null) {
            //le splitter right n'est pas visible
            ctrlResize.mShowRight()
            ctrlResize.mConstruitRight(function (contentElementRight) {
                contentElementTagMiseEnPage = contentElementRight
                contentElementTagMiseEnPage.css({
                    "position": "relative",
                    "background-color": theme.backgroundcolorTooltip
                })
                mShow()
            })
        } else {
            //le splitter right est visible avec les tag dedans
            dxCtrlMiseEnPage.element().fadeOut(300, function () {
                dxCtrlMiseEnPage.element().remove();
                dxCtrlMiseEnPage = null;
            })
            mShow()
        }

        function mShow() {
            dxCtrlLstTag = $("<div style='width:100%;height:100%;position:absolute;display:none;border-top:" + theme.border + ";border-bottom:" + theme.border + ";border-right:" + theme.border + ";'/>").appendTo(contentElementTagMiseEnPage).dxCtrlEmailLstTag({
                bddCtrl: option.bddCtrl,
                lstLibelleAdded: ["LIEN EMAILING"],
                lstChampSaisie: option.dataHtml.lstChampSaisie,
                onLstChampSaisieChanged: function (lstChampSaisie) {
                    option.dataHtml.lstChampSaisie = lstChampSaisie
                    lstTagIsDirty = true
                },
                elementEditorHtml: elementEditorHtml,
                allowChampForDestinataire: option.allowChampForDestinataireForTag,
                onClose: function () { mShowHideListTag(elementEditorHtml); }
            }).dxCtrlEmailLstTag("instance")
            dxCtrlLstTag.element().fadeIn(300)
        }
    }

    this.mGetIdTestAcid = function () {
        if (dxAssistant) { return dxAssistant.mGetIdTestAcid() }
        else { return dxHtmlEditor.mGetIdTestAcid() }
    }

    this.mChangeLstSaisie = function (lstChampSaisie) {
        lstTagIsDirty = true
        option.dataHtml.lstChampSaisie = lstChampSaisie
        if (lstChampSaisie.length > 0 && !dxCtrlLstTag) {
            mShowHideListTag(dxHtmlEditor)
        }
    }
    this.mChangeHtml = function (html, htmlSansBody, funcFin) {
        if (miseEnPageIsDisplayed) mShowHideMiseEnPage()
        if (html.isAssistant()) {
            if (this.isAssistant()) {
                //on est dans l'assistant
                //on remplace tout
                //on charge le HTML dans l'assistant
                dxAssistant.mSetHtml(html, funcFin)
            } else {
                //on passe en mode assistant et on charge le HTML
                option.bddCtrl.mAjaxCall({ command: "savepageassistanthtml", html: html }, function (data) {
                    mSwitchVersAssistantHtml(data.urlhtml, html, [], function () { funcFin() })
                })
                ////on est dans l'éditeur
                //if (remplacerTout) {
                //} else {
                //    //on insère le html sans body de l'assistant dans le mail
                //    dxHtmlEditor.mInsertContent(htmlSansBody)
                //    funcFin()
                //}
            }
        } else {
            //la source est un html 'classique'
            if (this.isAssistant()) {
                //la destination est un assistant
                //on passe en mode éditeur
                //et on remplace tout
                mSwitchVersEditeurHtml(html, funcFin)
            } else {
                //la destination est un editeur
                dxHtmlEditor.mSetContent(html)
                //if (remplacerTout) { dxHtmlEditor.mSetContent(html) }
                //else { dxHtmlEditor.mInsertContent(htmlSansBody) }
                funcFin()
            }
        }
    }
    this.mGetHtml = function () {
        if (option.readOnly) {
            if (option.dataHtml.html.isAssistant()) { return option.dataHtml.html }
            else { return dxHtmlEditor.mGetContent() }
        } else {
            if (dxAssistant) { return dxAssistant.mGetHtml() }
            else { return dxHtmlEditor.mGetContent() }
        }
    }
    this.isAssistant = function () {
        return dxAssistant != null
    }

    this.element = function () { return container }
    this.focus = function () {
        if (container.closest("body").length == 0) return
        if (dxAssistant) { dxAssistant.focus() }
        else { dxHtmlEditor.focus() }
    }
    //this.dispose = function () {
    //    if (ctrlResize) ctrlResize.dispose()
    //    if (dxHtmlEditor) dxHtmlEditor.dispose()
    //}

    mConstruit();
}